import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from 'styled-components'
import { BrowserRouter } from 'react-router-dom'
import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client'

import App from './App'
import { GlobalStyle } from './GlobalStyles'
import { AuthenticationProvider } from '@tiltify/ui/contexts/AuthenticationContext'
import { IntlContextProvider } from '@tiltify/ui/contexts/IntlContext'
import { ToggleThemeProvider } from '@tiltify/ui/contexts/ThemeContext'
import { ThemeToggleContextProvider } from '@tiltify/shared/contexts'
import { setupPublicClient } from '@tiltify/ui/utils'
import theme from './theme'
import { FullWindowLoading, Helmet } from '@tiltify/ui'
import { RouteContextProvider } from './contexts/RouteContext'
import { useGA } from '@tiltify/ui/hooks/useGA'

const container = document.getElementById('root')
const root = createRoot(container!)

const Index = (): JSX.Element => {
  const [client, setClient] = useState<ApolloClient<NormalizedCacheObject>>()
  const { initGA, pageView } = useGA()

  useEffect(() => {
    initGA(process.env.REACT_APP_TILTIFY_GA)
    pageView()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setupPublicClient()
      .then((res: ApolloClient<NormalizedCacheObject>) => setClient(res))
      .catch(() => {})
  }, [])

  if (!client) return <FullWindowLoading />

  return (
    <ApolloProvider client={client}>
      <RouteContextProvider>
        <AuthenticationProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthenticationProvider>
      </RouteContextProvider>
    </ApolloProvider>
  )
}

root.render(
  <>
    <Helmet description='Jingle Jam is fundraising on Tiltify' title='Jingle Jam' />
    <ToggleThemeProvider>
      <ThemeToggleContextProvider>
        <ThemeProvider theme={theme}>
          <IntlContextProvider>
            <Index />
          </IntlContextProvider>
        </ThemeProvider>
      </ThemeToggleContextProvider>
    </ToggleThemeProvider>
    <GlobalStyle />
  </>
)
